import { defineComponent } from "../lib/component.ts";

interface CollectionHeaderRefs {
  toggle?: HTMLButtonElement;

  filters?: HTMLUListElement;
}

class CollectionHeader extends defineComponent<CollectionHeaderRefs>()(["toggle", "filters"]) {
  connectedCallback(): void {
    super.connectedCallback();
    this.refs.toggle.addEventListener("click", this.#handleToggle, {
      signal: this.signal,
    });
    this.refs.filters.addEventListener("click", this.#handleFilterClick, {
      signal: this.signal,
    });
  }

  #handleToggle = (): void => {
    const isOpen = this.toggleAttribute("open");
    this.refs.toggle.setAttribute("aria-expanded", String(isOpen));
  };

  #handleFilterClick = (event: Event): void => {
    if (event.target instanceof Element && event.target.closest("a")) {
      this.removeAttribute("open");
      this.refs.toggle.setAttribute("aria-expanded", "false");
    }
  };
}

if (!customElements.get("collection-header")) {
  customElements.define("collection-header", CollectionHeader);
}
